export default "__VITE_ASSET__Bn30X3U5__"